/*
 * The move to K4Community 5.x: after each sign-in and each silent renewal, the web app asks the
 * migration service whether the community it acts in has moved, and goes to 5.x's sign-in when it
 * has. 5.x then carries this sign-in over by token exchange, or signs in on identity.
 *
 * The answer is { action: "stay" } or { action: "switch", href }. Only an https href on a
 * k4community.com host is followed: anything else is treated as stay, so this can never send
 * someone to another site.
 */

export function switchTarget(answer)
{
	if(answer?.action !== 'switch' || typeof answer.href !== 'string')
	{
		return null;
	}

	let url;
	try {
		url = new URL(answer.href);
	} catch(e) {
		return null;
	}

	const host = url.hostname;
	if(url.protocol !== 'https:' || !(host === 'k4community.com' || host.endsWith('.k4community.com')))
	{
		return null;
	}

	return url.href;
}

export async function switchCheck({ url, jwt, communityId, fetchImpl = fetch })
{
	if(!url || !jwt || !communityId)
	{
		return null;
	}

	const response = await fetchImpl(`${url}/switch`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${jwt}`
		},
		body: JSON.stringify({ communityId })
	});

	if(!response.ok)
	{
		throw new Error(`the migration service answered ${response.status}`);
	}

	return switchTarget(await response.json());
}
